import { useServerLikes } from './store'

/**
 * Get server likes enabled value
 * Used for enable/disable usage of server likes in likes request
 *
 * @author Vladyslav Vladinov
 */
export const getServerLikesActive = () => {
	return useServerLikes.getState().isServerLikesEnabled
}

export const getLocalLikesActive = () => !getServerLikesActive()
